import useClientConfigs from '@tbx/customhooks/useClientConfigs';

export const hasRedirectToStores = (isDesktop) => {
  const { enabledResponsiveWeb, enableResponsivePlayer } = useClientConfigs();

  if (!isDesktop && (!enabledResponsiveWeb || !enableResponsivePlayer)) {
    return true;
  }

  return false;
};
